import React from "react";

import { wikiArticleUrl } from "@/mk2/apps/wiki/utils";
import { Link } from "@/mk2/components/Link";
import { Panel } from "@/mk2/components/Panel";
import { PanelHeading } from "@/mk2/components/PanelHeading";
import { WikiArticleEntity } from "@/mk2/schemas";
import { RELATED_WIKI_ARTICLES } from "@/mk/autogenerated/translation";

import styles from "./PostDetailRelated.mscss";

interface OwnProps {
    isContest: boolean;
    relatedWikiArticles?: WikiArticleEntity[];
}

export function RelatedWikiArticlesPanel({ isContest, relatedWikiArticles }: OwnProps) {
    if (isContest || !relatedWikiArticles || relatedWikiArticles.length === 0) {
        return null;
    }

    return (
        <Panel className={styles.PostDetailRelated__box}>
            <PanelHeading title={RELATED_WIKI_ARTICLES} headingLevel={2} />
            <ul className={styles.PostDetailRelated__linkedArticles}>
                {relatedWikiArticles.map((article) => (
                    <li key={article.id} className={styles.PostDetailRelated__linkedArticlesItem}>
                        <div className={styles.PostDetailRelated__linkedArticlesItemHeader}>
                            <Link to={wikiArticleUrl(article)}>
                                <b>{article.title}</b>
                            </Link>
                        </div>
                    </li>
                ))}
            </ul>
        </Panel>
    );
}
